import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // In production this is where you'd forward to Sentry/LogRocket.
    console.error('Render error:', error, info?.componentStack);
    this.setState({ componentStack: info?.componentStack || '' });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, componentStack: '' });
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-5 px-6 text-center">
          <h1 className="font-display text-3xl font-bold text-slate-900 dark:text-white">
            Something went wrong
          </h1>
          <p className="max-w-md text-sm text-slate-500 dark:text-slate-400">
            We hit an unexpected error. Try reloading the page — if it keeps happening, please contact support.
          </p>
          <div className="flex gap-3">
            <button onClick={() => window.location.reload()} className="btn-secondary">Reload</button>
            <button onClick={this.handleReset} className="btn-primary">Go Home</button>
          </div>
          <details className="mt-4 w-full max-w-2xl whitespace-pre-wrap rounded-lg bg-slate-100 p-4 text-left text-xs text-slate-700 dark:bg-slate-800 dark:text-slate-300">
            <summary className="cursor-pointer font-mono text-sm">
              {String(this.state.error?.message || this.state.error)}
            </summary>
            {this.state.error?.stack}
            {this.state.componentStack}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
